<div class="collapsible-card">
  <button
    type="button"
    class="card-toggle"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()"
  >
    <div class="toggle-left">
      <app-icon [type]="IconType.CREDIT_CARD" [size]="20"></app-icon>
      <span class="toggle-title">SEPA-Lastschrift</span>
    </div>
    <app-icon
      [type]="IconType.CHEVRON_DOWN"
      [size]="20"
      [class.rotated]="isExpanded()"
    ></app-icon>
  </button>

  @if (isExpanded()) {
    <div class="section-form">
      @if (!selectedOrgId) {
        <p class="muted-text">
          Bitte wählen Sie zuerst einen Verein aus, um Ihre Bankverbindung zu
          hinterlegen.
        </p>
      } @else if (isLoading()) {
        <p class="muted-text">Lädt…</p>
      } @else {
        <!-- Existing mandate summary -->
        @if (mandate() && !editingBankData()) {
          <dl class="mandate-summary">
            <div class="mandate-row">
              <dt>Kontoinhaber</dt>
              <dd>{{ mandate()!.accountHolderName }}</dd>
            </div>
            <div class="mandate-row">
              <dt>IBAN</dt>
              <dd>{{ mandate()!.ibanMasked }}</dd>
            </div>
            <div class="mandate-row">
              <dt>Mandatsreferenz</dt>
              <dd>{{ mandate()!.mandateReference }}</dd>
            </div>
            <div class="mandate-row">
              <dt>Status</dt>
              <dd>
                <span
                  class="status-pill"
                  [class.active]="mandate()!.usable"
                >
                  {{ mandate()!.usable ? 'Aktiv' : 'Nicht verwendbar' }}
                </span>
              </dd>
            </div>
          </dl>

          <div class="form-actions">
            <button class="btn btn-danger-secondary" (click)="revoke()">
              Mandat widerrufen
            </button>
            <button class="btn btn-tertiary" (click)="startEdit()">
              Bankverbindung ändern
            </button>
          </div>
        } @else {
          <!-- New / replacement mandate form -->
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="sepaHolder" class="form-label">Kontoinhaber</label>
              <input
                id="sepaHolder"
                type="text"
                formControlName="accountHolderName"
                class="form-input"
                autocomplete="name"
                placeholder="Vor- und Nachname"
              />
              @if (hasError('accountHolderName', 'required')) {
                <span class="error-text">Pflichtfeld</span>
              }
            </div>

            <div class="form-group">
              <label for="sepaIban" class="form-label">IBAN</label>
              <input
                id="sepaIban"
                type="text"
                formControlName="iban"
                class="form-input"
                inputmode="text"
                autocomplete="off"
                autocapitalize="characters"
                spellcheck="false"
                placeholder="DE00 0000 0000 0000 0000 00"
              />
              @if (hasError('iban', 'required')) {
                <span class="error-text">Pflichtfeld</span>
              }
              @if (hasError('iban', 'invalidIban')) {
                <span class="error-text">Ungültige IBAN</span>
              }
            </div>

            <div class="form-group">
              <label for="sepaBic" class="form-label">BIC (optional)</label>
              <input
                id="sepaBic"
                type="text"
                formControlName="bic"
                class="form-input"
                inputmode="text"
                autocomplete="off"
                autocapitalize="characters"
                spellcheck="false"
                placeholder="z.B. COBADEFFXXX"
              />
              @if (hasError('bic', 'pattern')) {
                <span class="error-text">Ungültige BIC</span>
              }
            </div>

            <div class="form-group mandate-consent">
              <p class="mandate-text">
                Ich ermächtige {{ creditorName }}, Zahlungen von meinem Konto
                mittels SEPA-Lastschrift einzuziehen, und weise mein Kreditinstitut
                an, die von {{ creditorName }} auf mein Konto gezogenen
                Lastschriften einzulösen.
              </p>
              <app-toggle-switch
                [checked]="form.get('accepted')?.value === true"
                (checkedChange)="setAccepted($event)"
                label="SEPA-Lastschriftmandat erteilen"
              ></app-toggle-switch>
              @if (hasError('accepted', 'required')) {
                <span class="error-text">
                  Bitte erteilen Sie das SEPA-Lastschriftmandat
                </span>
              }
            </div>

            <div class="form-actions">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="cancelEdit()"
                [disabled]="isSaving()"
              >
                Abbrechen
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="!form.valid || isSaving()"
                [class.btn-loading]="isSaving()"
              >
                {{ isSaving() ? 'Speichern…' : 'Mandat speichern' }}
              </button>
            </div>
          </form>
        }
      }
    </div>
  }
</div>
